<script setup lang="ts">
import { useScreenSize } from "../../../utils/useScreenSize";
import { GeneralLedger } from "../../../types/models";
import {
  formatNumber,
  isEmpty,
} from "../../../utils/CommonFunctions";
const { isMobile } = useScreenSize();

defineProps<{
  data?: GeneralLedger[];
}>();
</script>

<template>
  <table
    v-if="data && data.length > 0"
    :class="[isMobile ? 'w-[350px]' : 'w-[500px]']"
  >
    <thead class="bg-white dark:bg-gray-900">
      <tr>
        <!-- Fixed left column -->
        <th
          class="z-20 px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Account Name
        </th>
        <th
          class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Debit (Dr.)
        </th>
        <th
          class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Credit (Cr.)
        </th>
      </tr>
    </thead>
    <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
      <template v-for="acct in data" :key="acct.uid">
        <tr v-if="!isEmpty(acct.account_name)">
          <td class="px-4 py-3 text-left">
            {{ acct.account_name }}
          </td>
          <td class="px-4 py-3 text-right">
            {{ formatNumber(acct.debit) }}
          </td>
          <td class="px-4 py-3 text-right">
            {{ formatNumber(acct.credit) }}
          </td>
        </tr>
      </template>
    </tbody>
    <thead class="bg-gray-200 dark:bg-gray-700">
      <tr>
        <th
          class="z-20 px-4 py-3 text-left text-md font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Total
        </th>
        <th
          class="px-4 py-3 text-right text-md font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          {{
            formatNumber(
              data[data.length - 1].debit
            )
          }}
        </th>
        <th
          class="px-4 py-3 text-right text-md font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          {{
            formatNumber(
              data[data.length - 1].credit
            )
          }}
        </th>
      </tr>
    </thead>
  </table>
</template>
